import { CookiesControllerState } from './../../domain/interfaces/CookiesStateTypes';
export default {
  getBannerVisibility: (state: CookiesControllerState) => {
    return state.isBannerVisible
  },
}